import jwt_decode from 'jwt-decode';

export const checkAuthorization = async () => {
    let token = localStorage.getItem('INX.2FA.TOKEN') || '';
    if (token) {
        return [true, null];
    }
    return [false, null];
};

export const removeAuthorization = () => {
    localStorage.clear();
};

const parseJwt = token => {
    return jwt_decode(token);
};

export const JwtParse = parseJwt;
